import * as React from 'react'
import {connect} from 'react-redux'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import * as Source from '..'
import * as App from '../../../app/types'
import { Loading } from '../../../components/loading'
import * as RasaModal from '../../../components/modal'
import { RasaInput, RasaSelectInput } from '../../../components/rasa-input'
import * as FilterGroups from '../../filter-group'
import * as Actions from './actions'
import * as Constants from './constants'
import './styles.css'
import * as Utils from './utils'

interface SubmitProps {
  submitModal: Actions.SubmitFilterModal
}

interface AppProps {
  app: App.State,
  filterGroups: FilterGroups.FilterGroupsState,
  subscriptionId: Source.SourceId,
}

type ModalProps = Source.WrappedModalState &
                  RasaModal.DispatchState &
                  SubmitProps & AppProps

const FilterModalComponent =
  ({app, filterGroups, modal, submitModal, showModal, subscriptionId, updateModal}: ModalProps) =>
<Modal className="modal-lg subscription-filter-modal" isOpen={modal.isOpen} toggle={showModal}>
  <form className="k-form">
    <ModalHeader toggle={showModal}>Enter new Filters</ModalHeader>
    <ModalBody>
      {modal.data.filter_source === Constants.SOURCE_GROUP &&
        // For groups - show the dropdown selector of available groups
        <RasaSelectInput label="Filter Group"
                         options={Utils.filterGroupsAsModalDropdown(filterGroups.data)}
                         onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                           updateModal({name: 'filter_group_id', value: e.target.value})}
                         value={modal.data.filter_group_id}/>}
      {(modal.data.filter_source === Constants.SOURCE_GROUP && modal.data.filter_group_id <= 0) &&
        <RasaInput label="Group Name"
                   placeholder=""
                   value={modal.data.group_name}
                   onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      updateModal({name: 'group_name', value: e.target.value})} />}
      {(modal.data.filter_source === Constants.SOURCE_TAG || modal.data.filter_group_id <= 0) &&
        // for tags, or if the group has selected the "Add New", then show the text field
        <RasaInput label="Tags"
                  placeholder=""
                  value={modal.data.tags}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      updateModal({name: 'tags', value: e.target.value})} />}
      <label className="k-form-field rasa-hidden-field">
        <span>Type</span>
        <RasaModal.Dropdown
            name="filter_type"
            data={Utils.filterTypesAsModalDropdown()}
            selected={modal.data.filter_type}
            onChange={updateModal}
        />
      </label>
      <label className="k-form-field rasa-hidden-field">
        <span>Source</span>
        <RasaModal.Dropdown
            name="filter_source"
            data={Utils.sourceTypesAsModalDropdown()}
            selected={modal.data.filter_source}
            onChange={updateModal}
        />
      </label>
    </ModalBody>
    <ModalFooter>
      {modal.isSubmitting ? <Loading size={Loading.Sizes.SMALL} /> : <span/>}
      <Button color="primary"
              disabled={modal.isSubmitting || !Utils.modalStateValid(modal.data)}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                submitModal(app.selectedCommunity, subscriptionId, modal.data)}>
        Save
      </Button>
      <Button onClick={showModal}>Cancel</Button>
    </ModalFooter>
  </form>
</Modal>

export const FilterModal = connect(
  ({app, filterGroups}: AppProps) => ({app, filterGroups}),
  {
    showModal: Actions.toggleModal,
    submitModal: Actions.createFilters,
    updateModal: Actions.updateModalField,
  },
)(FilterModalComponent)

export const UncontrolledFilterModal = connect(
  ({app, filterGroups}: AppProps) => ({app, filterGroups}),
)(FilterModalComponent)



// WEBPACK FOOTER //
// ./src/pages/source-config/filters/modal.tsx